<app-shared-card additionalClasses="">
  <div
    (click)="openEvent(eventId(), eventType())"
    class="flex flex-col rounded-2xl overflow-hidden cursor-pointer min-w-0"
  >
    <div
      class="flex-1 p-3 md:p-4 min-w-0 grid grid-cols-[1fr_auto] items-center gap-3 md:gap-4"
    >
      <div class="min-w-0">
        <div class="flex items-start gap-1.5 md:gap-2 mb-1.5 md:mb-2 min-w-0">
          <app-badge [label]="getEventCategoryLabel(eventType(), computedEventCategory())" [tailwindColor]="getEventCategoryColor(computedEventCategory())"></app-badge>
          @if (showLiveBadge()) {
            <app-live-badge [isLive]="isEventCurrentlyLive() | async" />
          }
        </div>

        <h3
          class="text-base md:text-lg font-semibold text-gray-800 leading-tight mb-2 md:mb-3 min-w-0 line-clamp-2"
        >
          {{ title() }}
        </h3>

        <div class="flex flex-col gap-1.5 md:gap-2 text-xs md:text-sm text-gray-600">
          <app-datetime-info-line [startDate]="event()!.startDate" [endDate]="event()!.endDate" />

          @if (!!location()) {
            <app-location-info-line [location]="location()" />
          } @else if (keywords().length > 0) {
            <app-keywords-info-line [keywords]="keywords()" />
          }
        </div>
      </div>
      <div class="hidden md:block">
        <i-lucide [name]="ChevronRight" class="w-5 h-5 text-gray-400" />
      </div>
    </div>
  </div>
</app-shared-card>
